<div class="form-infoscreen-wrapper">
  <app-icon-label icon="tv" text="Skærmtekst" size="medium"></app-icon-label>

  <form [formGroup]="form" class="form-fields">
    <!-- Screen Text Field -->
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic">
      <mat-label>Navn - infoskærm</mat-label>
      <input
        matInput
        formControlName="screenText"
        (input)="onFieldInput('screenText')"
        (change)="onScreenTextChange($event.target.value)"
      />
      @if (showCopyScreenText()) {
        <button
          matSuffix
          matIconButton
          type="button"
          aria-label="Kopiér til de øvrige tider"
          matTooltip="Kopiér til de øvrige tider"
          (click)="requestCopy('screenText')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      }
    </mat-form-field>

    <!-- Level Field -->
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic">
      <mat-label>Infoskærmstekst</mat-label>
      <input
        matInput
        formControlName="level"
        (input)="onFieldInput('level')"
        (change)="onLevelChange($event.target.value)"
      />
      @if (showCopyLevel()) {
        <button
          matSuffix
          matIconButton
          type="button"
          aria-label="Kopiér til de øvrige tider"
          matTooltip="Kopiér til de øvrige tider"
          (click)="requestCopy('level')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      }
      <mat-hint>Ved kamp: angiv niveau (fx '1. Senior', 'Serie A'). Ved møder: angiv mødetype.</mat-hint>
    </mat-form-field>
  </form>
</div>
